<template>
  <div class="w-100 bg-white" style="min-height:100vh;">
    <Header page="GALLERY"></Header>
    <div class="pt-5">
      <div class="px-10 mt-5 mb-5">
        <div v-if="is_load" class="text-center py-5">
          <loader></loader>
        </div>
        <template v-else>
          <div class="w-50 mx-auto py-5 my-5" v-if="error != ''">
            <ErrorMessage :message="error"></ErrorMessage>
          </div>
          <template v-else>
            <template v-for="gallery in gallerys">
              <div class="position-relative" :id="gallery.name" style="top:-80px"></div>
              <div class="row slim-grid-row mb-5" v-if="gallery.image_list.length != 0">
                <div class="col-12 col-lg-12 position-sticky target-sticky">
                  <div class="position-stickyz top-84px d-block">
                    <p class="mb-0 pb-4 text-20 font-semibold">{{gallery.name}}</p>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mb-3" 
                  v-for="(image_slider,index_image_slider) in gallery.image_list" 
                  :key="index_image_slider" 
                  @click="toggleDetail(index_image_slider,gallery.image_list)">
                    <img :src="image_slider.image_url" class="object-fit w-100 cursor-pointer" alt="" height="300">
                </div>
              </div>
              <CoolLightBox 
                v-if="detail.show"
                :items="detail.list"
                srcName="image_url" 
                :index="detail.selected"
                :fullScreen="true"
                :closeOnClickOutsideMobile="true"
                @close="toggleDetail()"
                >
              </CoolLightBox>
            </template>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import Footer from '../../components/ticket/Footer';
  import Header from '../../components/ticket/Header';
  import CoolLightBox from 'vue-cool-lightbox'
  import moment from 'moment'
  import { mapGetters } from 'vuex';
  import { get } from '@/services/index'
  export default {
    components:{
      Footer,
      Header,
      CoolLightBox
    },
    data() {
      return {
        is_load: false,
        gallerys: [],
        error: '',
        detail:{
          show: false,
          list: [],
          selected: null
        }
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
      is_mobile_view(){
				return window.innerWidth > 768 ? false : true
			}
    },
    mounted(){
      this.loadFirstData()
    },
    methods:{
      loadFirstData(){
        this.is_load = true
        this.error = ''
        Promise.all([this.loadGallery()])
        .catch(err=>this.error = err)
        .finally(()=>this.is_load = false)
      },
      loadGallery(){
        return new Promise((success,fail)=>{
          get("CORE_HOTEL",`v2/merchant-gallery/${this.getMerchant.id}`).then(response=>{
            let res = response.data
            if(res.success){
              this.gallerys = res.data
              success()
            }else{
              fail(res.message)
            }
          })
        })
      },
      toggleDetail(index=null,list){
        if(index != null){
          this.detail.show = true
          this.detail.list = list
          setTimeout(()=>{
            this.detail.selected = index
          },100)
        }else{
          this.detail = {
            show: false,
            list: [],
            selected: null
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/ticket/TicketGallery.vue